import qs from "qs";
import axios from "axios";
import Jsona from "jsona";
import profileService from "@/store/services/profile-service";
import store from "./../index";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

async function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  console.log("options: ", options);
  console.log("ENTRA1");

  return axios.get(`${url}/users?populate=deep,3`, options).then((response) => {
    var users = response.data;
    return {
      list: users,
      //meta: response.data.meta,
    };
  });
}

async function listLight(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  console.log("ENTRA2");

  return axios.get(`${url}/users?populate=*`, options).then((response) => {
    var users = response.data;
    return {
      listLight: users,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/users/${id}?populate=*`, options)
    .then((response) => {
      let user = response.data;
      console.log(user);
      return user;
    });
}

function add(user) {
  /* const payload = jsona.serialize({
    stuff: user,
    includeNames: null,
  }); */
  var payload = user;

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/users?include=roles`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(user) {
  var payload = user;
  /*  const payload = jsona.serialize({
    stuff: user,
    includeNames: [],
  }); */

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  console.log("CONDE:");
  return axios
    .put(`${url}/users/${user.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/users/${id}`, options);
}

function upload(user, image) {
  const payload = new FormData();
  payload.append("attachment", image);

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/uploads/users/${user.id}/profile-image`, payload, options)
    .then((response) => {
      return response.data.url;
    });
}

async function fetchEmpleados(params) {
  console.log("service search: ", params);
  return axios
    .get(`${url}/empleados-list`, {
      params: params,
    })
    .then((response) => {
      let empleados = response.data;
      return empleados;
    });
}

export default {
  list,
  listLight,
  get,
  add,
  update,
  destroy,
  upload,
  fetchEmpleados,
};
